import type { GetDeliverablesResData } from '@/api/Sherpa/Tdm/types';

export enum ViewMode {
  Daily = 'DAY',
  Weekly = 'WEEK',
  Monthly = 'MONTH',
  Quarterly = 'QUARTER',
  Yearly = 'YEAR',
}

export type GanttChartMode = 'interactive' | 'print';

export type GanttData = Record<string, any> & {
  id: number;
  startDate: string;
  dueDate: string;
  name: string;
};

export type DeliverableItem = {
  id: number;
  name: string;
  status: string;
  dueDate: string | null;
  notes: any;
  projectId: number;
  file: any;
  templateFile: any;
  metaData: { leadTitleId: number; supportTitleId: number };
  isDeleted: boolean;
  commentCount: number;
  phase: string;
  project: { name: string; id: number };
  startDate: string;
};

export type DeliverableTooltipData = GetDeliverablesResData & {
  domEl: HTMLElement;
  startDate?: string;
};

export type GanttItemDragProps = {
  onDragComplete?: DragCompleteFn;
  onDragStart?: (targetId: string) => void;
};

export type DragCompleteFn = (
  id: string | number,
  newDuration: Duration,
  oldDuration: Duration,
  callback: (applyChanges: boolean) => void
) => void;

export type Duration = { startDate: Date; endDate: Date };

export type DragState = {
  startX: number;
  targetEl: HTMLElement | null;
  targetId: string | null;
  dragType: 'drag' | 'resize-left' | 'resize-right';
  initialLeft: number;
  initialWidth: number;
  newStart: Date | null;
  newEnd: Date | null;
};

type GanttHeaderGroup = {
  items: number[];
  label: string;
};

export type GanttHeaderMajorGroups = Record<
  string,
  GanttHeaderGroup & {
    isTodayGroup?: boolean;
  }
>;

export type GanttHeaderMinorGroups = Record<string, GanttHeaderGroup>;

export type MovedItem = {
  id: string | number;
  newDuration: Nullable<Duration>;
  oldDuration: Nullable<Duration>;
};

export type Nullable<T> = {
  [P in keyof T]: T[P] | null;
};
